"use strict";

function isNullOrEmpty(obj) {
  return !obj ||
    (Array.isArray(obj) && !obj.length) ||
    Object.entries(obj).length === 0;
}

module.exports = {
  isNullOrEmpty
};
